module.exports = __webpack_public_path__ + "static/media/careem_wink_green.c1d2d93e.svg";